import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import Dialog from "components/common/Dialog/Dialog";
import Button from "components/common/Button/Button";
import {
  ContainerButtonStyle,
  DeleteButtonsStyle,
} from "./DeletePromotionCode.style";
import { useDeletePromotionCodeMutation } from "redux/api/promotionCodes/promotionCodes";
import { IPromotionCodesDelete } from "./DeletePromotionCode.types";
import { useSnackBar } from "hooks/useSnackBar";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function DeletePromotionCode({
  id,
  code,
  openDeleteDialog,
  setOpenDeleteDialog,
  getDeletedCodeAfterUpdate
}: IPromotionCodesDelete) {
  const { t } = useTranslation();
  const [deletedCode,setDeletedCode]=useState<any>({id:id,code:code});

  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();

  const [deleteCode, { data, error, isLoading }] =
    useDeletePromotionCodeMutation();

  if (error) {
    displayErrorApiSnackBar(error);
  }
  if (data) {
    displaySuccessSnackBar(t("promotion_codes.successfully_deleted"));
    getDeletedCodeAfterUpdate(undefined)

  }

  const closeDeleteAlertDialog = useCallback(() => {
    setOpenDeleteDialog(false);

  }, [setOpenDeleteDialog]);

  const onSuccessDeleteAlert = (event: React.FormEvent) => {
    event.preventDefault();
    deleteCode(id);
    closeDeleteAlertDialog();


  };

  return (
    <Dialog
      open={openDeleteDialog}
      handleClose={closeDeleteAlertDialog}
      title={t("promotion_codes.delete")}
      size={"xs"}
    >
      <div style={{textAlign: "center"}}> <ErrorOutlineIcon sx={{fontSize:"90PX",color:"#f54040"}}  ></ErrorOutlineIcon></div>

      <form onSubmit={onSuccessDeleteAlert}>
        <p>
          {t("common.delete_message")}
          <span style={{ fontWeight: "bold", marginLeft: 5 }}>{code}</span>!
        </p>
        <DeleteButtonsStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              title={t("common.cancel_button")}
              onClick={closeDeleteAlertDialog}
            />
          </ContainerButtonStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              type="submit"
              loader={isLoading}
              title={t("common.confirm_button")}
            />
          </ContainerButtonStyle>
        </DeleteButtonsStyle>
      </form>
    </Dialog>
  );
}
export default DeletePromotionCode;
